import { SET_MASTERDATA } from './constants';

export const setMasterdata = (data) => (dispatch) => {
    dispatch({
        type: SET_MASTERDATA,
        data,
    });
};